import { DocumentType } from 'types/DocumentType';
import { type DocumentRoleBindingLookup } from 'types/Roles';
import { nowOrServerTimestamp } from 'utils/FirestoreUtils';

import { DocumentSchema } from './DocumentSchema';

export class FolderSchema extends DocumentSchema {
    author: string = '';
    dateModified = nowOrServerTimestamp();
    name: string = '';
    tags: string[] = [];
    type: DocumentType = DocumentType.DEFAULT;
    archived: boolean = false;
    members: DocumentRoleBindingLookup = {};
    memberKeys: string[] = [];
}

export class FolderPublicSchema {
    type = DocumentType.DEFAULT;
    name: string = '';
}
